import React from 'react'
import HeroSectionLotr from './HeroSectionLotr';
import CharactersLotr from './CharactersLotr';
import FooterLotr from './FooterLotr';
import BooksLotr from './BooksLotr';
import MoviesLotr from './MoviesLotr';

function HomeLotr() {
  return (
    <>
      <HeroSectionLotr />
      <CharactersLotr />
      <BooksLotr />
      <MoviesLotr />
      <FooterLotr />
    </>
  );
}

export default HomeLotr